export default __webpack_public_path__ + "static/media/newbg.6d91560d.jpeg";